import React from 'react';
import { BreadcrumbJsonLd, NextSeo } from 'next-seo';
import { getMarketingUrl } from '~/helpers/url';
import { getArticleBreadcrumb, getArticleUrl } from '~/helpers/article';

const Seo = ({ article }) => {
  const title = getTitle(article);
  const { description } = article;
  const url = getMarketingUrl(getArticleUrl(article));

  return (
    <>
      <NextSeo
        title={title}
        description={description}
        canonical={`${url}/`}
        twitter={{
          cardType: 'summary_large_image',
          site: '@repman_io'
        }}
        openGraph={{
          url,
          title,
          description,
          images: [{
            url: getMarketingUrl('/og-image.png')
          }],
          site_name: 'Repman: Private PHP Package Repository Manager',
          type: 'article',
          locale: 'en_US'
        }}
      />
      <Breadcrumb article={article} />
    </>
  );
};

const Breadcrumb = ({ article }) => {
  const articleBreadcrumb = getArticleBreadcrumb(article);
  const itemsList = [{
    name: 'Home',
    item: getMarketingUrl()
  }, {
    name: 'Docs',
    item: getMarketingUrl('/')
  }, ...articleBreadcrumb]
    .map((item, i) => ({
      position: i + 1,
      name: item.name,
      item: item.item
    }));

  return <BreadcrumbJsonLd itemListElements={itemsList} />;
};

const getTitle = ({ metaTitle, originalTitle }) => {
  const parts = [
    'Docs',
    'Repman - PHP Repository Manager'
  ];

  if (metaTitle) {
    parts.unshift(metaTitle);
  } else if (originalTitle) {
    parts.unshift(originalTitle);
  }

  return parts.join(' | ');
};

export default Seo;
